export const APP_NAME = 'Shesha Boilerplate';

export const ACCESS_TOKEN_NAME = 'xDFcxiooPQxazdndDsdRSerWQPlincytLDCarcxVxv';
export const ENTERPRISE_HEADER_FORM_ID = { module: 'shesha.enterprise', name: 'header' };
export const LOGIN_FORM_ID = { module: 'shesha.enterprise', name: 'login' };
